import { Tooltip } from "@mui/material";
import cn from "../../utils/cn";
import { AI_STATUS_LABELS } from "../../utils/aiInterviewApi";

// Same shades as the interview status pills (fill 100, border 300, text 800)
const TONES = {
  neutral: "border-gray-300 bg-gray-100 text-gray-700",
  info: "border-blue-300 bg-blue-100 text-blue-800",
  live: "border-violet-300 bg-violet-100 text-violet-800",
  success: "border-green-300 bg-green-100 text-green-800",
  warning: "border-amber-300 bg-amber-100 text-amber-800",
  danger: "border-red-300 bg-red-100 text-red-800",
};

const STATUS_TONES = {
  SCHEDULED: "info",
  PREPARING: "info",
  READY: "info",
  BOT_JOINING: "live",
  WAITING_FOR_CANDIDATE: "live",
  IN_PROGRESS: "live",
  PAUSED: "warning",
  EVALUATING: "live",
  COMPLETED: "success",
  CANDIDATE_NO_SHOW: "warning",
  CANDIDATE_DECLINED: "warning",
  FAILED: "danger",
  CANCELLED: "neutral",
};

// `summary` comes from aiSummaryOf(). Renders nothing when AI was never enabled.
export default function AIInterviewBadge({ summary, onClick, className }) {
  if (!summary) return null;

  const status = summary.enabled === false ? "CANCELLED" : summary.status;
  const label = AI_STATUS_LABELS[status] || "AI enabled";
  const score = typeof summary.overallScore === "number" ? ` · ${summary.overallScore.toFixed(1)}/10` : "";
  const tooltip = status === "FAILED" ? summary.failureMessage : "";

  const content = (
    <>
      {label}
      {status === "COMPLETED" && score}
    </>
  );
  const classes = cn(
    "inline-flex items-center gap-1.5 whitespace-nowrap rounded-full border px-2.5 py-0.5 text-xs font-medium",
    TONES[STATUS_TONES[status] || "neutral"],
    onClick && "cursor-pointer hover:brightness-95",
    className
  );

  const badge = onClick ? (
    <button type="button" onClick={onClick} className={classes} aria-label={`AI interview: ${label}. View details`}>
      {content}
    </button>
  ) : (
    <span className={classes}>{content}</span>
  );

  if (!tooltip) return badge;
  return (
    <Tooltip title={tooltip} arrow>
      <span className="inline-flex">{badge}</span>
    </Tooltip>
  );
}
